<template>
	<div class="edit-pre-made-treatment">
		<Breadcrumbs :items="items" />
		<v-container fluid class="mt-3">
			<v-row no-gutters>
				<v-col cols="12" md="12">
					<PreMadeTreatmentForm
						:treatment="treatment"
						:edit="true"
						:category="category"
						@edit-treatment="editTreatment"
						@cancel="goToPremadeTreatments"
					/>
				</v-col>
				<v-col cols="6" md="6" class="mt-3">
					<v-alert v-model="error" color="red" icon="warning">
						<translate>Error</translate>
					</v-alert>
				</v-col>
			</v-row>
		</v-container>
	</div>
</template>

<script>
import PreMadeTreatmentForm from "@/components/settings/PreMadeTreatmentForm.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import axios from "axios";

export default {
	name: "EditPreMadeTreatment",
	props: ["treatment", "category", "custom", "customTreatment"],
	components: {
		PreMadeTreatmentForm,
		Breadcrumbs
	},
	data: () => ({
		error: false
	}),
	computed: {
		categoryName() {
			return ({
				nut: this.$gettext("Nutrition"),
				qg: "Qi Gong",
				tn: "Tui Na"
			})
		},
		items() {
			var item = {};
			if (this.custom) {
				item = {
					text: this.customTreatment.name,
					disabled: false,
					link: true,
					to: { name: "custom-pre-made-treatments", params: { ctid: this.customTreatment.id, custom: true } }
				};
			}
			else {
				item = {
					text: this.categoryName[this.category],
					disabled: false,
					link: true,
					to: { name: "pre-made-treatments", params: { category: this.category, custom: false } }
				};
			}
			return [
				{
					text: this.$gettext("Dashboard"),
					disabled: false,
					link: true,
					to: { name: "dashboard" }
				},
				{
					text: this.$gettext("Treatments"),
					disabled: false,
					link: true,
					to: { name: "treatments" }
				},
				item,
				{
					text: this.treatment.name,
					disabled: true,
					link: true
				},
				{
					text: this.$gettext("Edit"),
					disabled: true,
					link: true
				}
			];
		}
	},
	methods: {
		editTreatment(treatment) {
			this.error = false;
			const formData = new FormData();
			formData.append("name", treatment.name);
			formData.append("text", treatment.text);
			if(this.custom) formData.append("custom_treatment_id", this.customTreatment.id);
			else formData.append("category", this.category);
			console.log(this.custom);
			axios
				.post("/api/premade_treatments/" + treatment.id, formData)
				.then(response => {
					console.log(response.data);
					if (response.data.result == "edited") {
						this.goToPremadeTreatments();
					} else {
						this.error = true;
					}
				})
				.catch(error => {
					console.log(error);
					this.error = true;
				});
		},
		goToPremadeTreatments() {
			this.$router.push(this.items[2].to);
		}
	}
};
</script>